export default class ClientInvoiceLineItemModify {
  constructor() {
    this.AssignmentIds = [];
    this.LineItemIds = [];
    this.LineItemId = null;
    this.AllItemsInTheSearchSetAreSelected = false;
    this.NumberOfItemsSelected = 0;
    this.AssignmentSearchItem = {};
    this.ClientLineSearchItem = {};

    // The group is written only when the user switches this on; an empty field must not clear the
    // groups of every selected assignment when only the amounts are edited.
    this.AdHocGroupEnabled = false;
    this.AdHocGroup = '';
    this.FieldworkFee = '';
    this.ClientFee = '';
    this.CcTravel = '';
    this.CcAdditionalFee = '';
    this.CcMisc = '';
    this.CcReimbursement = '';
    this.CcGaming = '';
    this.EvaluatorFee = '';
    this.EvTravel = '';
    this.EvAdditionalFee = '';
    this.EvMisc = '';
    this.EvReimbursement = '';
    this.EvGaming = '';

    this.ClCiId = '';
    this.ClLliid = '';
    this.InternalLineItemTypeLookupValue = '';
    // Drives which fields the line item editor locks: on a finalized (or paid) invoice only the
    // internal line item type stays editable.
    this.IsInvoiceFinalized = false;
    this.TiedToType = '';
    this.ClCfId = '';
    this.ClServiceId = '';
    //this.ClOpportunityId = '';
    this.ClDesc = '';
    this.ClTotal = 0;
    this.CurrencyId = '';
    this.CcId = '';
  }
}
